import { render, staticRenderFns } from "./ModalParticipantsManage.vue?vue&type=template&id=3b3d2874&scoped=true&"
import script from "./ModalParticipantsManage.vue?vue&type=script&lang=ts&"
export * from "./ModalParticipantsManage.vue?vue&type=script&lang=ts&"
import style0 from "./ModalParticipantsManage.vue?vue&type=style&index=0&id=3b3d2874&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d2874",
  null
  
)

export default component.exports